import { PublicTenantRuntype, TenantDetails } from '@luminovo/api-contracts';

const TENANT_DETAILS_STORAGE_KEY = 'luminovo.tenant.details';

export interface CachedTenantDetails {
    details: TenantDetails;
    fetchedAt: number;
}

export function loadFromSessionStorage(): { details: TenantDetails } | null {
    try {
        const stored = sessionStorage.getItem(TENANT_DETAILS_STORAGE_KEY);
        if (!stored) return null;

        const parsed = JSON.parse(stored) as CachedTenantDetails;
        const details = PublicTenantRuntype.parse(parsed.details);

        return { details };
    } catch {
        // Silently fail if sessionStorage is not available or data is invalid
        try {
            sessionStorage.removeItem(TENANT_DETAILS_STORAGE_KEY);
        } catch {}
        return null;
    }
}

export function saveToSessionStorage(details: TenantDetails): void {
    try {
        const cached: CachedTenantDetails = {
            details,
            fetchedAt: Date.now(),
        };
        sessionStorage.setItem(TENANT_DETAILS_STORAGE_KEY, JSON.stringify(cached));
    } catch {
        // Silently fail if sessionStorage is not available
    }
}
